import { Dialog, styled } from '@mui/material';

import { allowTransientProps } from 'common/utils/styled';

export const DialogPrompt = styled(
    Dialog,
    allowTransientProps
)<{ $isCompact?: boolean; $minWidth?: string }>(({ $isCompact = false, $minWidth = '430px' }) => ({
    '& .MuiDialog-paper': {
        padding: '20px',
        minWidth: $minWidth,
        width: $isCompact ? 'min-content' : 'max-content',
    },
    '& .MuiDialogActions-root': {
        justifyContent: 'center',
        '& .MuiButton-root': { width: '160px', height: '55px', margin: '0 8px' },
    },
    '& .MuiDialogTitle-root': { '& > svg': { display: 'block', margin: '0 auto 20px auto' }, textAlign: 'center' },

    '@media print': {
        '& .MuiDialog-paper': { minWidth: '100%', minHeight: '100%', margin: 0 },
        '& .MuiPaper-rounded': {
            borderRadius: 0,
        },
        '& .MuiPaper-root': {
            transition: 'none',
        },
        '& .MuiBackdrop-root': {
            backgroundColor: '#ffffff',
        },
    },
}));
